exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-analisitransazionale-tsx": () => import("./../../../src/pages/analisitransazionale.tsx" /* webpackChunkName: "component---src-pages-analisitransazionale-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-privacy-tsx": () => import("./../../../src/pages/privacy.tsx" /* webpackChunkName: "component---src-pages-privacy-tsx" */),
  "component---src-pages-servizi-tsx": () => import("./../../../src/pages/servizi.tsx" /* webpackChunkName: "component---src-pages-servizi-tsx" */)
}

